export default "__VITE_ASSET__BIE0FdP9__"